import React from 'react'
import { LoaderSwitcher, MerchantCategoriesLoader } from 'router/Loaders'
import LocationDashboard from 'components/Locations/Dashboard'

export const LocationDashboardWrapper = () => {
  return (
    <MerchantCategoriesLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <LocationDashboard />
        </LoaderSwitcher>
      )}
    </MerchantCategoriesLoader>
  )
}
